import { egresadosApiCall } from "../../../../axios/apiClient";
const controller = "autenticacion";

export default {
    loginGoogle: async (token) => {
        let response = { success: true };
        const method = `google`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, { token: token });
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    loginEgresado: async (data) => {
        let response = { success: true };
        const method = `egresado`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    checkToken: async (token) => {
        let response = { success: true };
        const method = `checkToken`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, { token: token });
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
}